import { EditorState, EditorSelection } from '@codemirror/state';
import { indentUnit } from '@codemirror/language';
import { classHighlightStyle } from '@codemirror/highlight';
import { history } from '@codemirror/history';
import { csharp } from "./lang-csharp.js";
import lineSeparator from "./line-separator.js";
import keymap from "./keymap.js";
import { sendChangesToServer } from "./server/send-changes.js";
import { slowUpdateLinter } from "./server/slow-update-linter.js";
import { connectionState } from "./server/connection-state.js";
import { infotipsFromServer } from "./server/infotips.js";
import { autocompletionFromServer } from "./server/autocompletion.js";
export function createState(connection, options = {}) {
  return EditorState.create({ ...(options.initialText ? {
      doc: options.initialText
    } : {}),
    ...(options.initialCursorOffset ? {
      selection: EditorSelection.single(options.initialCursorOffset)
    } : {}),
    extensions: [indentUnit.of('    '), EditorState.lineSeparator.of(lineSeparator), history(), csharp(), classHighlightStyle, connectionState(connection), sendChangesToServer(connection), slowUpdateLinter(connection, options), infotipsFromServer(connection), autocompletionFromServer(connection), // has to go last so that more specific keymaps
    // in e.g. autocomplete have more priority
    keymap]
  });
}